import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { CalendarOptions, DateSelectArg, EventClickArg, EventApi, FullCalendarComponent, Calendar } from '@fullcalendar/angular';
import esLocale from '@fullcalendar/core/locales/es';

export interface Event{
  title:string,
  start:Date,
  end?:Date,
  backgroundColor:string,
  borderColor?:string,
  textColor?:string,
  extendedProps?:any,
  editable:boolean
  display:string,
}

export interface Control{
  left:string,
  center:string,
  right:string
}

@Component({
  selector: 'app-shared-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarSharedComponent implements OnInit {

  @Input() events:Event[] = [];
  @Input() controls:Control;
  @Output() prevEmit:EventEmitter<any> = new EventEmitter<any>();

  calendarOptions: CalendarOptions = { };

  constructor() { }

  ngOnInit() {
    this.calendarOptions = {
      headerToolbar: {left: this.controls.left, center: this.controls.center, right: this.controls.right},
      initialView: 'dayGridMonth',
      weekends: true,
      editable: false,
      selectable: true,
      selectMirror: true,
      dayMaxEvents: true,
      locale : esLocale,
      locales : [{ code : 'es'}],
      contentHeight: 'auto',
      eventTimeFormat: {
        hour: '2-digit',
        minute: '2-digit'
      },
      eventClick: this.handleEventClick.bind(this),
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.calendarOptions.events = (changes.events)?changes.events.currentValue:this.events;
  }

  handleEventClick(clickInfo: EventClickArg){
    this.prevEmit.emit(clickInfo.event.extendedProps);
  }
}
